/* RESPONSIBLE TEAM: team-inbox-management */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ConversationController extends Controller {
  queryParams = [
    { previewSideConversation: 'preview_side_conversation' },
    { sidebarTab: 'sidebar_tab' },
    { monitorId: 'monitor_id' },
  ];

  declare previewSideConversation?: string;
  declare sidebarTab?: string;
  @tracked monitorId: string | null = null;
}
